import { mixpanel } from '@fiverr-private/obs';

/**
 * Sends an event over mixpanel reporting channel.
 * @param mixpanelOptions
 * @param {string?} mixpanelOptions.type - The mixpanel event type
 * @param {...*} mixpanelOptions.params - The mixpanel event parameters
 */
export const sendMixpanel = ({ type, ...params }) => {
    type ? trackEvent(type, params) : trackPageView(params);
};

/**
 * Tracks a single event in Mixpanel.
 *
 * @param {string} type - The mixpanel event type
 * @param {Object} params - The mixpanel event parameters
 */
const trackEvent = (type, params) => {
    mixpanel.track(type, params);
};

/**
 * Tracks a page view event in Mixpanel.
 *
 * @param {Object} params - The mixpanel event parameters
 */
const trackPageView = (params) => {
    mixpanel.trackPageView(params);
};
